import { createContext, useContext } from 'react';

export interface CompositeDocumentStorageContextInterface {
  isDocumentStorageAvailable?: boolean;
}

export const CompositeDocumentStorageContext = createContext<Nullable<CompositeDocumentStorageContextInterface>>(null);

export const useCompositeDocumentStorageContext = () => {
  const context = useContext(CompositeDocumentStorageContext);
  return context || {};
};
